// @ts-nocheck
// "Aproveite também" — MESMO visual de antes (tamanhos, cores, foto, círculo "+"), com uma única novidade: nos itens que têm descrição,
// clicar no item abre a descrição completa (sem selecionar); a seleção continua sendo só o círculo "+" nesses itens.
// Itens sem descrição se comportam exatamente como antes (clicar na linha seleciona). Os dados (resolvedBumps), a seleção
// (selectedBumps) e os totais continuam sendo os da BookingPage: este componente só desenha e chama onToggle/isSelected (mesma lógica de antes).
import React, { useId, useState } from 'react';
import { Box, Typography } from '@mui/material';

interface Props {
  bumps: any[];                       // resolvedBumps da BookingPage (mesma ordem, mesmo limite)
  isSelected: (b: any) => boolean;    // mesma regra de seleção de antes
  onToggle: (b: any) => void;         // mesmo setSelectedBumps de antes
  accentColor: string;
  T: any;
}

export default function AddonsList({ bumps, isSelected, onToggle, accentColor, T }: Props) {
  const uid = useId().replace(/:/g, '');
  const [aberto, setAberto] = useState<string | null>(null);

  const textP = T?.textPrimary ?? '#111827';
  const textS = T?.textSecondary ?? '#64748b';
  const borda = T?.border ?? '#eef2f7';
  const foco = { '&:focus-visible': { outline: `2px solid ${accentColor}`, outlineOffset: 2 } };

  return (
    <Box data-testid="addons-v2" sx={{ bgcolor: T?.bg ?? '#fff', borderRadius: 2.5, border: `1.5px solid ${T?.border ?? '#f0f0f0'}`, overflow: 'hidden' }}>
      <Box sx={{ px: 2, py: 1.4, borderBottom: `1px solid ${T?.border ?? '#f5f5f5'}` }}>
        <Typography sx={{ fontWeight: 900, fontSize: { xs: 19, sm: 21 }, lineHeight: 1.1, color: T?.textPrimary ?? '#111827' }}>Aproveite também</Typography>
        <Typography sx={{ fontSize: { xs: 10, sm: 11 }, lineHeight: 1.2, color: T?.textSecondary ?? '#64748b' }}>Itens recomendados para seu atendimento</Typography>
      </Box>
      {bumps.map((bump: any, i: number) => {
        const isBumpSel = !!isSelected(bump);
        const key = bump._bumpType === 'manual' ? `manual-${bump.name}` : `${bump._bumpType}-${bump.id}`;
        // texto completo: descrição curta + detalhes (sem repetir o que for igual), um parágrafo por linha
        const paragrafos = Array.from(new Set([bump.description, bump.details].filter((x: any) => typeof x === 'string' && x.trim()).flatMap((x: string) => x.split(/\n+/)).map((x: string) => x.trim()).filter(Boolean)));
        const temDescricao = paragrafos.length > 0;
        const expandido = aberto === key;
        const idDet = `${uid}-d${i}`;
        const alternarDescricao = () => setAberto(expandido ? null : key);
        const preco = `R$ ${Number(bump.price).toFixed(2).replace('.', ',')}`;
        const promo = bump.original_price && Number(bump.original_price) > Number(bump.price);
        const miolo = (
          <>
            {bump.image_url && (
              <Box sx={{ width: 74, height: 74, borderRadius: 3, overflow: 'hidden', bgcolor: T?.surfaceAlt ?? '#f8fafc', border: `1px solid ${T?.border ?? '#e2e8f0'}`, flexShrink: 0 }}>
                <img src={bump.image_url_md || bump.image_url} alt={bump.name} loading="lazy" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </Box>
            )}
            <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'left' }}>
              <Typography component="span" fontSize={16} fontWeight={800} sx={{ color: isBumpSel ? accentColor : textP, lineHeight: 1.14, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{bump.name}</Typography>
              {temDescricao && (
                // linha da descrição (igual à de antes) + "Ver mais" logo depois do texto. No celular o bloco tem a largura da tela, então o "Ver mais" é um item
                // comum da linha (a descrição só encurta se faltar espaço). A partir de sm o modal tem a largura do CONTEÚDO: lá o "Ver mais" tem largura 0 (o texto
                // transborda para a direita) e a descrição reserva o espaço dele; assim a largura natural da linha, e portanto a do modal, continuam as de antes.
                <Box component="span" sx={{ display: 'flex', alignItems: 'baseline', mt: 0.06, minWidth: 0 }}>
                  {bump.description && <Typography component="span" fontSize={8} sx={{ color: textS, lineHeight: 1.05, flex: '0 1 auto', minWidth: 0, maxWidth: { xs: 'none', sm: 'calc(100% - 72px)' } }} noWrap>{bump.description}</Typography>}
                  <Box component="span" aria-hidden="true" sx={{ flex: 'none', width: { xs: 'auto', sm: 0 }, overflow: 'visible', whiteSpace: 'nowrap', fontSize: 12, lineHeight: 1, color: textS, textDecoration: 'underline', textUnderlineOffset: '2px' }}>
                    <Box component="span" sx={{ pl: '8px' }}>{expandido ? 'Ver menos' : 'Ver mais'}</Box>
                  </Box>
                </Box>
              )}
              <Box component="span" sx={{ mt: 1.05, display: 'flex', alignItems: 'baseline', gap: 1.1, flexWrap: 'wrap' }}>
                {promo && (
                  <Typography component="span" fontSize={15} fontWeight={900} sx={{ color: '#94a3b8', textDecoration: 'line-through', textDecorationThickness: '2px', lineHeight: 1, opacity: 1 }}>
                    R$ {Number(bump.original_price).toFixed(2).replace('.', ',')}
                  </Typography>
                )}
                <Typography component="span" fontSize={21} fontWeight={900} sx={{ color: accentColor, lineHeight: 1, letterSpacing: '0', textShadow: '0.2px 0 0 currentColor' }}>{preco}</Typography>
              </Box>
            </Box>
          </>
        );
        const miolSx = { display: 'flex', alignItems: 'stretch', gap: 2, flex: 1, minWidth: 0 };
        return (
          <Box key={key} data-selected={isBumpSel ? 'true' : 'false'}
            // item com descrição: clicar abre/fecha a descrição; item sem descrição: clicar seleciona (igual a antes)
            onClick={temDescricao ? alternarDescricao : () => onToggle(bump)}
            sx={{ cursor: 'pointer', borderBottom: `1px solid ${borda}`, bgcolor: isBumpSel ? `${accentColor}08` : (T?.bg ?? '#fff'),
              '&:hover': { bgcolor: isBumpSel ? `${accentColor}12` : (T?.surfaceAlt ?? '#fafafa') }, transition: 'background 0.12s' }}>
            <Box sx={{ display: 'flex', alignItems: 'stretch', gap: 2, px: 2.6, py: 1.9 }}>
              {temDescricao ? (
                <Box component="button" type="button" aria-expanded={expandido} aria-controls={idDet} aria-label={`${expandido ? 'Ocultar' : 'Ver'} a descrição de ${bump.name}`}
                  sx={{ ...miolSx, p: 0, m: 0, border: 0, bgcolor: 'transparent', color: 'inherit', font: 'inherit', textAlign: 'left', cursor: 'pointer', borderRadius: '6px', ...foco }}>{miolo}</Box>
              ) : (
                <Box sx={miolSx}>{miolo}</Box>
              )}
              <Box component="button" type="button" aria-pressed={isBumpSel} aria-label={`${isBumpSel ? 'Remover' : 'Adicionar'} ${bump.name} por ${preco}`}
                onClick={(e: any) => { e.stopPropagation(); onToggle(bump); }}
                sx={{ width: 32, height: 32, alignSelf: 'center', borderRadius: '50%', border: `2px solid ${isBumpSel ? accentColor : (T?.border ?? '#cbd5e1')}`, p: 0, m: 0, cursor: 'pointer',
                  bgcolor: isBumpSel ? accentColor : (T?.surface ?? '#fff'), display: 'flex', alignItems: 'center', justifyContent: 'center',
                  flexShrink: 0, transition: 'all 0.12s', boxShadow: isBumpSel ? `0 6px 14px ${accentColor}33` : 'none', ...foco }}>
                <Typography component="span" fontSize={13} fontWeight={800} sx={{ color: isBumpSel ? '#fff' : accentColor, lineHeight: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                  {isBumpSel ? '✓' : '+'}
                </Typography>
              </Box>
            </Box>
            {temDescricao && (
              <Box id={idDet} hidden={!expandido} sx={{ mx: 2.6, pt: 1.3, pb: 1.9, borderTop: `1px solid ${borda}` }}>
                {paragrafos.map((p: string, k: number) => (
                  <Typography key={k} sx={{ fontSize: 13, lineHeight: 1.55, color: textS, mt: k ? 0.8 : 0, overflowWrap: 'anywhere' }}>{p}</Typography>
                ))}
              </Box>
            )}
          </Box>
        );
      })}
    </Box>
  );
}
